import { CUSTOMER_MAX_FILE_SIZE } from '@properties/application-restriction.properties';

/** Dialog width for the View Files modal, the files table needs a wide dialog. */
export const VIEW_FILES_MODAL_WIDTH = '70em';

/**
 * Page size of the files request. The endpoint only supports `page`/`pageSize`, so the modal takes the
 * whole list at once and does the searching, filtering, sorting and paging on the client.
 */
export const VIEW_FILES_FETCH_PAGE_SIZE = 500;

/** Number of files rendered by one page of the files table. */
export const VIEW_FILES_PAGE_SIZE = 10;

/** File extensions the file picker of the modal accepts. Must match the files API allow-list, which rejects anything else. */
export const VIEW_FILES_ALLOWED_EXTENSIONS: readonly string[] = ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png'];

/** `accept` attribute for the hidden file input, e.g. ".pdf,.xls,...". */
export const VIEW_FILES_ACCEPT_ATTRIBUTE = VIEW_FILES_ALLOWED_EXTENSIONS.map((extension) => `.${extension}`).join(',');

/** Size limit applied to every picked file, for every role. */
export const VIEW_FILES_MAX_FILE_SIZE_BYTES = CUSTOMER_MAX_FILE_SIZE;

/** Id of the `All` option of the file type filter — a sentinel that no real file extension can collide with. */
export const ALL_FILE_TYPES_ID = '__all__';
